import { useEffect, useState } from 'react';
import * as styled from './Student.styled.jsx'
import { useDispatch } from 'react-redux';
import { fetchAuthMe } from '../../../redux/slices/auth.js';
import LeftPanel from '../../../components/LeftPanel/LeftPanel.jsx';
import { Outlet } from 'react-router-dom';
import { MainContent } from '../../../styles/components/MainContent.styled.jsx';
import StarsIntro from '../../../components/StarsIntro/StarsIntro.jsx';


function Student({isTrial}) {
   const [userData, setUserData] = useState(null)
   const dispatch = useDispatch()
   const navList = [
      {name: 'Головна', link: "general"},
      {name: 'Розклад', link: "schedule"},
      {name: 'Домашнє завдання', link: "homework"},
      {name: 'Оплата', link: "payment"},
      {name: 'Матеріали', link: "materials"},
      {name: 'Словник', link: "vocabulary"}, 
      {name: 'Магазин', link: "shop"},
   ]
   const trialNavList = [
      {name: 'Головна', link: "general"},
      {name: 'Розклад', link: "schedule"},
      {name: 'Домашнє завдання', link: ""},
      {name: 'Ціни', link: "payment"},
      {name: 'Словник', link: ""}, 
      {name: 'Матеріали', link: ""},

   ]

   useEffect(() => {
      const studentData = async() => {
         const data = await dispatch(fetchAuthMe())

         setUserData(data.payload)

      }
      studentData()
      
   }, [dispatch])
   

   if(!userData) return
   return(
      <styled.Wrapper>
         <LeftPanel notAdmin userName={userData.name} pageTitle={"Мій кабінет"} navList={isTrial ? trialNavList : navList} currentRoute={isTrial ? '/trial-student': '/student'}/>
         <MainContent>
            <Outlet/>
         </MainContent>
         {!isTrial && <StarsIntro stars={userData.stars ?? 0} />}
      </styled.Wrapper>
   )
}

export default Student